import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { LoaderService } from '../../services/loader.service';


@Component({
  standalone: false,
  selector: 'bt-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnDestroy {

  @Input() public loaderId: string;

  public inLoading: boolean;
  public withContent: boolean;

  private subscription = new Subscription();

  constructor(private loaderService: LoaderService) { }

  public ngOnInit() {
    if (this.loaderId) {
      this.subscription = this.loaderService.createLoader(this.loaderId).pipe(filter(x => !!x)).subscribe(data => {
        this.inLoading = data.show;
        setTimeout(() => {
          const el = document.getElementById(this.loaderId);
          this.withContent = data.show && !!el && !!el.nextElementSibling;
        });
      });
    }
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
    this.loaderService.destroyLoader(this.loaderId);
  }
}
